import React from 'react';

import { dateRangeMed, newsDateString } from '../../../helpers/dates';
import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import { ILibraryEventType } from '../../../queries/fragments/libraryEventType';
import ImageWrapper from '../../image-wrapper/Image-wrapper';
import { PageComponentImageTags } from './page-component-image-tags';

interface PageComponentImageProps {
  image?: IContentfulImage;
  logo?: IContentfulImage;
  tags?: ILibraryEventType[];
  stickyImage?: boolean;
  header?: string;
  date?: string;
  isdatevisible?: boolean;
  eventDateFrom?: string;
  eventDateTo?: string;
  hasColoredBackground?: boolean;
  hasShadedOverlay?: boolean;
  node_locale: string;
}

export const PageComponentImage = ({
  image,
  logo,
  tags,
  header,
  date,
  isdatevisible,
  eventDateFrom,
  eventDateTo,
  stickyImage = false,
  hasColoredBackground = false,
  hasShadedOverlay = false,
  node_locale,
}: PageComponentImageProps) => {
  const stickyWrapperClass = 'lg:h-full';

  return (
    <div
      className={`h-auto pb-0 lg:pb-11 ${
        stickyImage ? stickyWrapperClass : ''
      }`}
    >
      <div
        className={`relative transform-gpu overflow-hidden rounded-xl md:rounded-xxl ${
          stickyImage ? 'lg:sticky lg:top-0' : ''
        }`}
      >
        {hasColoredBackground ? ( // This is for service page.
          <div className="flex aspect-1.5/1 items-center justify-center overflow-hidden bg-brand-white lg:bg-background-primary-light">
            {image && (
              <ImageWrapper
                gatsbyImageData={image?.gatsbyImageData}
                file={image?.file}
                svg={image?.svg}
                alt={image?.description ? image.description : ''}
                className="w-36"
              />
            )}
            {logo && (
              <ImageWrapper
                gatsbyImageData={logo?.gatsbyImageData}
                file={logo?.file}
                svg={logo?.svg}
                alt={logo?.description ? logo.description : ''}
                className="!absolute left-6 top-6 h-16 w-16 lg:left-8 lg:top-8 lg:h-20 lg:w-20"
              />
            )}
          </div>
        ) : (
          <>
            {image && (
              <ImageWrapper
                gatsbyImageData={image?.gatsbyImageData}
                file={image?.file}
                svg={image?.svg}
                alt={image?.description ? image.description : ''}
              />
            )}
            {logo && (
              <ImageWrapper
                gatsbyImageData={logo?.gatsbyImageData}
                file={logo?.file}
                svg={logo?.svg}
                alt={logo?.description ? logo.description : ''}
                className="!absolute left-6 top-6 h-16 w-16 bg-brand-white lg:left-8 lg:top-8 lg:h-20 lg:w-20"
                imgClassName="!object-contain"
              />
            )}
            {hasShadedOverlay && (
              <div className="absolute inset-0 bg-gradient-to-b from-transparency-gradient-from to-transparency-gradient-to"></div>
            )}
          </>
        )}

        <PageComponentImageTags
          tags={tags}
          endDate={eventDateTo}
          node_locale={node_locale}
        />

        {header && (date || eventDateTo) && (
          <>
            <div className="absolute bottom-6 left-6 text-brand-white lg:bottom-8 lg:left-8">
              {eventDateTo && eventDateFrom && (
                <div className="mb-1 font-title text-headings text-brand-yellow-1">
                  {dateRangeMed(eventDateFrom, eventDateTo, node_locale)}
                </div>
              )}
              <div className="hidden font-title text-headingm lg:block lg:pr-8">
                {header}
              </div>
              {(isdatevisible == null || isdatevisible == true) && date && (
                <div className="mt-4">{newsDateString(date, node_locale)}</div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
